import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import Toasted from "vue-toasted";
import Vuelidate from "vuelidate";
import moment from "moment";
import VTooltip from "v-tooltip";
import VueSweetalert2 from "vue-sweetalert2";
import VueClipboard from "vue-clipboard2";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faExternalLinkAlt,
  faCompressArrowsAlt,
  faSearchDollar,
  faProjectDiagram,
  faCircle,
  faUserSecret,
  faHourglassHalf,
  faLifeRing,
  faUsers,
  faMinusCircle,
  faWallet,
  faSync,
  faExclamationTriangle,
  faCoins,
  faSignOutAlt,
  faExchangeAlt,
  faEdit,
  faPlusCircle,
  faAngleDoubleRight,
  faAngleDown,
  faAngleUp,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleLeft,
  faSpinner,
  faTimes,
  faPhone,
  faUser,
  faPiggyBank,
  faBars,
  faTimesCircle,
  faCheckCircle,
  faDollarSign,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  faTrashAlt,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-regular-svg-icons";
import {
  faWhatsapp,
  faTelegramPlane,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faExternalLinkAlt,
  faCompressArrowsAlt,
  faSearchDollar,
  faProjectDiagram,
  faCircle,
  faUserSecret,
  faHourglassHalf,
  faLifeRing,
  faUsers,
  faWallet,
  faMinusCircle,
  faSync,
  faExclamationTriangle,
  faExchangeAlt,
  faCoins,
  faSignOutAlt,
  faAngleDown,
  faAngleUp,
  faEye,
  faEyeSlash,
  faEdit,
  faPlusCircle,
  faAngleDoubleRight,
  faAngleRight,
  faAngleDoubleLeft,
  faAngleLeft,
  faSpinner,
  faTimes,
  faTrashAlt,
  faWhatsapp,
  faTelegramPlane,
  faPhone,
  faUser,
  faPiggyBank,
  faBars,
  faCheckCircle,
  faTimesCircle,
  faDollarSign,
  faQuestionCircle
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

import "./assets/styles/index.css";

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.moment = moment;

var requireComponent = require.context(
  "./components",
  true,
  /[A-Z]\w+\.(vue|js)$/
);
requireComponent.keys().forEach(function(fileName) {
  var baseComponentConfig = requireComponent(fileName);
  baseComponentConfig = baseComponentConfig.default || baseComponentConfig;
  var baseComponentName =
    baseComponentConfig.name ||
    fileName.replace(/^.+\//, "").replace(/\.\w+$/, "");

  Vue.component(baseComponentName, baseComponentConfig);
});

var VueScrollTo = require("vue-scrollto");

Vue.use(VueScrollTo);

Vue.use(VueClipboard);
Vue.use(VueSweetalert2);
Vue.use(Vuelidate);
Vue.use(Toasted, {
  singleton: true,
});
Vue.use(VTooltip);

axios.interceptors.request.use((config) => {
  if (store.state.token) {
    config.headers.Authorization = "Bearer" + store.state.token;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => {
    if (response.status == 200) {
      if (response.data.count_ticket == undefined) {
        Vue.prototype.$countTicket = "";
      } else {
        Vue.prototype.$countTicket = response.data.count_ticket;
      }

      if (response.data.version == undefined) {
        Vue.prototype.$versionMismatch = false;
      } else {
        const appVersion = response.data.version.toString();
        const viewVersion = process.env.VUE_APP_VERSION.toString();

        Vue.prototype.$appVersion = appVersion;
        Vue.prototype.$appAnnouncement = response.data.announcements;

        if (appVersion != viewVersion) {
          Vue.prototype.$versionMismatch = true;
        } else {
          Vue.prototype.$versionMismatch = false;
        }
      }
    }
    return response;
  },
  (err) => {
    if (!err.response) {
      Vue.swal({
        showConfirmButton: true,
        title: "Something went wrong",
        text:
          "No response from server. Please try again or contact IT support if the problem persists.",
        icon: "warning",
      });
    } else if (err.response.status == 503) {
      const errMessage = err.response.data.error
        ? err.response.data.error
        : err.response.data.message;

      Vue.swal({
        showConfirmButton: true,
        title: "Whoops!",
        text: errMessage,
        icon: "warning",
      });
    } else if (
      err.response.status == 404 &&
      err.config.url.includes("/auth/bypass")
    ) {
      // Do nothing
    } else if (
      err.response.status == 401 &&
      !err.config.url.endsWith("login")
    ) {
      store.commit("changeLoginMessage", "Your session has expired");
      store.commit("destroyToken");
      router.push({ name: "Login" });
    } else if (
      err.response.status == 500 &&
      err.config.url.endsWith("refresh")
    ) {
      store.commit("changeLoginMessage", "Your session has expired");
      store.commit("destroyToken");
      router.push({ name: "Login" });
    } else if (err.response.status == 422) {
      // Validation error
      const errMessage = err.response.data.error
        ? err.response.data.error
        : err.response.data.message;

      Vue.swal({
        position: "bottom-end",
        showConfirmButton: false,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        title: "Whoops!",
        html: errMessage,
        icon: "warning",
      });
    } else if (
      err.response.status == 403 &&
      !err.config.url.endsWith("login")
    ) {
      Vue.swal({
        position: "bottom-end",
        showConfirmButton: false,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        title: "Whoops!",
        html: err.response.data.message,
        icon: "warning",
      });

      router.push({ name: "Unauthorized" });
    } else if (
      err.response.status != 422 &&
      err.response.status != 403 &&
      err.response.status != 409
    ) {
      Vue.swal({
        position: "bottom-end",
        showConfirmButton: false,
        toast: true,
        timer: 3000,
        timerProgressBar: true,
        title: "Whoops!",
        html: err.response.data.message,
        icon: "warning",
      });
    }

    return Promise.reject(err);
  }
);

Vue.mixin({
  methods: {
    userCan: (privilege) => store.getters.userCan(privilege),
    debounce(method, timer) {
      if (this.$_debounceTimer !== null) {
        clearTimeout(this.$_debounceTimer);
      }
      this.$_debounceTimer = setTimeout(() => {
        method();
      }, timer);
    },
  },
  created() {
    this.$_debounceTimer = null;
  },
  data() {
    return {
      perPageDropdown: [10, 15, 20, 25, 50],
      tablePageInfo: (params) =>
        `Showing ${params.firstRecordOnPage} to ${params.lastRecordOnPage} of Page ${params.currentPage}`,
    };
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

let successOptions = {
  type: "success",
  position: "bottom-center",
  duration: 5000,
};

// register the toast with the custom message
Vue.toasted.register(
  "notification_success",
  (payload) => {
    // if there is no message passed show default message
    if (!payload.message) {
      return "Success!";
    }

    // if there is a message show it with the message
    return payload.message;
  },
  successOptions
);

let infoOptions = {
  type: "info",
  position: "top-right",
  duration: 5000,
};

// register the toast with the custom message
Vue.toasted.register(
  "notification_info",
  (payload) => {
    // if there is no message passed show default message
    if (!payload.message) {
      return "Info";
    }

    // if there is a message show it with the message
    return payload.message;
  },
  infoOptions
);

let errorOptions = {
  type: "error",
  position: "bottom-center",
  duration: 5000,
};

// register the toast with the custom message
Vue.toasted.register(
  "notification_error",
  (payload) => {
    // if there is no message passed show default message
    if (!payload.message) {
      return "Error";
    }

    // if there is a message show it with the message
    return payload.message;
  },
  errorOptions
);

// Register a global custom directive called `v-focus`
Vue.directive("focus", {
  // When the bound element is inserted into the DOM...
  inserted: function(el) {
    // Focus the element
    el.focus();
  },
});
